const actionTypes = {
  SET_HELP_CENTER_INTEGRATION: 'SET_HELP_CENTER_INTEGRATION',
};

export default actionTypes;
